/**
 * Timer module - handles time calculations and formatting
 */

/**
 * Format time duration as HH:MM:SS
 * @param {number} milliseconds - Duration in milliseconds
 * @returns {string} Formatted time string
 */
export function formatTime(milliseconds) {
  const totalSeconds = Math.floor(milliseconds / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  return [hours, minutes, seconds].map(unit => unit.toString().padStart(2, '0')).join(':');
}

/**
 * Format timestamp as HH:MM:SS
 * @param {number} timestamp - Unix timestamp
 * @returns {string} Formatted time string
 */
export function formatTimestamp(timestamp) {
  const date = new Date(timestamp);
  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');
  const seconds = date.getSeconds().toString().padStart(2, '0');

  return `${hours}:${minutes}:${seconds}`;
}

/**
 * Calculate elapsed time from start
 * @param {number} startTime - Start timestamp
 * @param {number} currentTime - Current timestamp (default: now)
 * @returns {number} Elapsed milliseconds
 */
export function getElapsedTime(startTime, currentTime = Date.now()) {
  return currentTime - startTime;
}

/**
 * Timer class for managing interval updates
 */
export class Timer {
  constructor(callback, interval = 1000) {
    this.callback = callback;
    this.interval = interval;
    this.timerId = null;
    this.isRunning = false;
  }

  start() {
    if (this.isRunning) return;

    this.isRunning = true;
    this.timerId = setInterval(() => {
      this.callback();
    }, this.interval);

    // Call immediately
    this.callback();
  }

  stop() {
    if (!this.isRunning) return;

    this.isRunning = false;
    if (this.timerId) {
      clearInterval(this.timerId);
      this.timerId = null;
    }
  }

  restart() {
    this.stop();
    this.start();
  }
}
